import { Outlet, Navigate } from 'react-router-dom'

import { useAuth, useMe } from 'src/hooks'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { Loader } from 'src/components'

const PrivateCustomerRoute = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const { data: user, isLoading: isMeLoading } = useMe()

  if (isLoading || isMeLoading || !user) {
    return <Loader />
  }

  if (
    !isAuthenticated
    // || !user?.customer
  ) {
    return <Navigate to={joinAbsRoute(ROUTES.ACCOUNTS)} replace />
  }

  if (user?.suspended) {
    return <Navigate to={ROUTES.SUSPENDED} replace />
  }

  return <Outlet />
}

export default PrivateCustomerRoute
